"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _SectionTitle = _interopRequireDefault(require("./SectionTitle"));
var _helpers = require("../../helpers");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Acknowledgements = function Acknowledgements(_ref) {
  var formProps = _ref.formProps;
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: _style["default"].fieldset
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: _style["default"].fieldsetHeading
  }, "Acknowledgements"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "courseDescription.acknowledgements.displayInModal",
    component: _cccisdFormik.CccisdToggle,
    label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: "Display in modal?",
      tooltip: "Should we display acknowledgements in a modal?"
    })
  }), /*#__PURE__*/_react["default"].createElement(_SectionTitle["default"], {
    name: "acknowledgements",
    placeholder: "Acknowledgements"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wysiwygWrapper
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "courseDescription.acknowledgements.content",
    component: _cccisdFormik.CccisdWysiwyg,
    label: "Content",
    type: "textarea"
  })));
};
var _default = exports["default"] = Acknowledgements;